export function hasCmdKey() {
    return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
}
